export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
        "stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stores"])},
        "homepage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
        "blog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blog"])},
        "faq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ"])},
        "complaint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Complaint"])}
      },
      "de": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])},
        "stores": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filiale"])},
        "homepage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Home"])},
        "blog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blog"])},
        "faq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FAQ"])},
        "complaint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reklamation"])}
      }
    }
  })
}